import { LEARN } from 'constants/actionTypes';
import { routes } from 'constants/config';
import request from 'utils/request_ajax';

const requestContents = () => ({
  type: LEARN.CONTENTS.REQUEST,
});

export const receiveContents = ({ contents, topics, events }) => ({
  type: LEARN.CONTENTS.RECEIVE,
  events,
  contents,
  topics,
});

const initializeSearch = ({ search }) => ({
  type: LEARN.SEARCH.READY,
  search,
});

export function fetchAllContents() {
  return async dispatch => {
    dispatch(requestContents());
    const data = await request.get(routes.LEARN);
    dispatch(receiveContents(data));
    dispatch(initializeSearch(data));
  };
}
